import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

/**
 * Skeletons for the `/groups*` feed area only — the sidebar + column grid are
 * the shared GroupsLayout's job and stay painted while these load. These are
 * the single source of truth: used both as route `pendingComponent`s and as
 * the in-component loading state, so the skeleton always matches the page.
 */

function PostCardSkeletons() {
  return (
    <>
      {[0, 1, 2].map((i) => (
        <Card key={i}>
          <CardContent className="space-y-3 p-5">
            <div className="flex items-center gap-3">
              <Skeleton className="h-10 w-10 shrink-0 rounded-full" />
              <div className="flex-1 space-y-1.5">
                <Skeleton className="h-4 w-32 rounded" />
                <Skeleton className="h-3 w-20 rounded" />
              </div>
            </div>
            <Skeleton className="h-4 w-full rounded" />
            <Skeleton className="h-4 w-3/4 rounded" />
          </CardContent>
        </Card>
      ))}
    </>
  )
}

/** Matches GroupDetail: centered feed column + 320px right rail. */
export function GroupDetailFeedSkeleton() {
  return (
    <div
      className="grid h-full grid-cols-[minmax(0,1fr)_320px] gap-4 overflow-hidden"
      role="status"
      aria-label="Loading space"
    >
      <div className="overflow-y-auto">
        <div className="mx-auto max-w-[760px] space-y-4">
          <Card>
            <CardContent className="space-y-3 p-5">
              <Skeleton className="h-12 w-full rounded-md" />
            </CardContent>
          </Card>
          <PostCardSkeletons />
        </div>
      </div>
      <div className="space-y-3 overflow-y-auto">
        <Skeleton className="h-40 w-full rounded-2xl" />
        <Skeleton className="h-64 w-full rounded-2xl" />
      </div>
    </div>
  )
}

/** Matches the Mentions / Replies inbox: single centered column. */
export function GroupInboxFeedSkeleton() {
  return (
    <div className="overflow-y-auto" role="status" aria-label="Loading inbox">
      <div className="mx-auto max-w-[760px] space-y-4">
        <PostCardSkeletons />
      </div>
    </div>
  )
}
